import { useNavigate } from 'react-router-dom';
import PageHeader from '../../../Layout/PageHeader'
import { useState } from 'react';
import Table, { Column } from '../../../Components/Tables/Table';
import { ArrowLeftRight, PlusCircle, ThreeDotsVertical } from 'react-bootstrap-icons';
import { replenishmentoverviewcompletedlist, replenishmentoverviewinprogresslist, replenishmentoverview } from '../../../Data/testData';
import Tabs from '../../../Shared/Tab/Tab';
import ImportLayout from "../../../Layout/ImportLayout";
import ExportLayout from "../../../Layout/ExportLayout";
import CommonModal from '../../../Components/Modals/CommonModal';

const ReplenishmentOverview = () => {
    const pageName = "Replenishment";
    const navigation = useNavigate();
    const [showModalForImportAndExport, setShowModalForImportAndExport] =
    useState({
      importModal: false,
      exportModal: false,
    });
    const [show, setShow] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const handleShow = () => setShow(!show);
    const [isAddButtonDisable, setAddButtonDisable] = useState(false);
    const [showRowClicked, setShowRowClicked] = useState(false);
    console.log(showRowClicked);

    const handelDetailScreenAction = (data: any) => {
        navigation(`/inventory/replenishment/details/${data.replenishmentNum}`)
    };
    const handelInactiveAction = (data: any) => { };
    const handelDeleteAction = (data: any) => { };
    const handelSelectRows = (selectedRow: Set<number>) => {
        setAddButtonDisable(selectedRow.size > 0);
    };

    const handleRowClick = (data: any) => {
        if (showRowClicked == false) {
            navigation(
                `/inventory/replenishment/details/${data.replenishmentNum}`
            );
        }
    };
    const columns: Column[] = [
        {
            name: "Replenishment#",
            selector: (row: { replenishmentNum: string }) => (
                <span onClick={() => handleRowClick(row)} className="cursor-pointer text-primary " >
                    {row.replenishmentNum}
                </span>
            ),
            enableSorting: true
        },
        {
            name: "Description ",
            selector: (row: { description: string }) =>(
                <span   title={row.description.length > 15 ? row.description : ""}>
                {row.description.length > 15
                  ? `${row.description.slice(0, 15)}...`
                  : row.description}
              </span>
        
            ),
        },
        {
            name: "Created on",
            selector: (row: { createOn: string }) => row.createOn,
        },
        {
            name: "No. of Lines",
            selector: (row: { noOfLines: string }) => row.noOfLines,
        },
        {
            name: "Assigned To",
            selector: (row: { assignedTo: number }) => row.assignedTo,
        },
        {
            name: "Status",
            selector: (row: { status: string }) => {
                return row.status === "New" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-blue">
                        New
                    </span>
                ) : row.status === "Backorder" ? (
                    <span className="badge text asn-overview-status asn-overview-status-border-red">
                        Backorder
                    </span>
                ) : row.status === "Completed" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-green">
                        Completed
                    </span>
                ) : row.status === "Ready to Check-in" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-blue">
                        Ready to Check-in
                    </span>
                ) : row.status === "Ready to Unload" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-blue">
                        Ready to Unload
                    </span>
                ) : row.status === "Ready to Receive" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-blue">
                        Ready to Receive
                    </span>
                ) : row.status === "In Progress" ? (
                    <span className="badge asn-overview-status asn-overview-status-border-yellow">
                        In Progress
                    </span>
                ) : (
                    <></>
                );
            },
        },
        {
            name: (
                <>
                    <ArrowLeftRight className="me-2" /> <PlusCircle />
                </>
            ),
            selector: (row: any) => (
                <>
                    <span
                        className="cursor-pointer dropdown-toggle action-menu border-none list-ellipse-ms"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={() => setShowRowClicked(true)}
                    >
                        <ThreeDotsVertical />
                    </span>
                    <ul className="dropdown-menu action-items">
                        <li
                            className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
                            onClick={() => handelDetailScreenAction(row)}
                        >
                            Detail Screen
                        </li>
                        <li
                            className="cursor-pointer ms-3 mb-1 fs-14 fw-bold"
                            onClick={() => handelInactiveAction(row)}
                        >
                            Assign
                        </li>
                    </ul>
                </>
            ),
        },
    ];

    const onCurrentPageChange = (page: number) => {
        // Handle page change here if needed
        console.log('Page changed to:', page);
    };
    const tabs = [
        {
            order: 0,
            label: "New | " + replenishmentoverview.length,
            content: (
                <div>
                    <Table
                        columns={columns}
                        data={replenishmentoverview}
                        pagination={{
                            recordsPerPage: 15,
                            totalRecords: replenishmentoverview.length,
                            onCurrentPageChange: onCurrentPageChange
                        }}
                        CheckboxStatus={true} enableSorting={true}
                    />
                </div>

            ),
            visibility: true,
            status: true,
        },
        {
            order: 1,
            label: "In Progress | " + replenishmentoverviewinprogresslist.length,
            content: (
                <Table
                    columns={columns}
                    data={replenishmentoverviewinprogresslist}
                    pagination={{
                        recordsPerPage: 15,
                        totalRecords: replenishmentoverviewinprogresslist.length,
                        onCurrentPageChange: onCurrentPageChange
                    }}
                    enableSorting={true}
                    CheckboxStatus={true}
                />
            ),
            visibility: true,
            status: false,
        },
        {
            order: 2,
            label: "Completed | " + replenishmentoverviewcompletedlist.length,
            content: <div >
                <Table
                    columns={columns}
                    data={replenishmentoverviewcompletedlist}
                    pagination={{
                        recordsPerPage: 15,
                        totalRecords: replenishmentoverviewcompletedlist.length,
                        onCurrentPageChange: onCurrentPageChange
                    }}
                    enableSorting={true}
                    CheckboxStatus={true}
                />
            </div>

            ,
            visibility: true,
            status: true,
        },
    ];
    return (

        <>
            <PageHeader
                name="Create"
                isShowUpload={true}
                addUrl="/inventory/replenishment/create"
                setShowModalForImportAndExport={setShowModalForImportAndExport}
                showModalForImportAndExport={showModalForImportAndExport}
            />

            <div className="clearfix"></div>

            <h5 className="text-start mt-1 mb-3">{pageName}</h5>
            <div>
                <Tabs tabs={tabs} isCheckbox={false} />
            </div>

            <div className="inbound-CheckIn-Table-Main-Div"></div>
            <CommonModal
                show={showModalForImportAndExport.importModal}
                handleClose={() => setShowModalForImportAndExport((preValue: any) => {
                    return { ...preValue, importModal: false };
                })}
                heading={"Import File"}
                content={<ImportLayout handleClose={handleShow} />}
                modalSize="modal-lg"
                footerButtonsActive={false}
                customClassNameForBody=""
                customClassNameForHeader="create-kit-orders"
            />
            <CommonModal
                show={showModalForImportAndExport.exportModal}
                handleClose={() => setShowModalForImportAndExport((preValue: any) => {
                    return { ...preValue, exportModal: false };
                })}
                heading={"Export"}
                content={<ExportLayout handleClose={handleShow} />}
                modalSize="modal-lg"
                footerButtonsActive={false}
                customClassNameForBody=""
                customClassNameForHeader="create-kit-orders"
            />
        </>
    )
}

export default ReplenishmentOverview